export default "__VITE_ASSET__B8FVcMjx__"